import ApiService from './api.service'
import { TokenService } from './storage.service'

class handleError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const apiUrlRecurso = '/recurso';

const RecursoService = {

    share: async function (data) {
        try {
            const response = await ApiService.post(`${apiUrlRecurso}/share`, data)
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            console.log(error);
            throw new handleError(error.response.status, error.response.data);
        }
    },

    save: async function(data) {
        try {
            const response = await ApiService.post(apiUrlRecurso, data);
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();
            return response.data.success;
        }catch (error) {
            console.log(error);
            throw new handleError(error.response.status, error.response.data.detail);
        }
        
    },

    uploadFile: async function(file) {
        try {
            const response = await ApiService.post(`${apiUrlRecurso}/upload`, file);
            ApiService.mount401Interceptor();
            return response.data.success;
        }catch(error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    list: async function(page,data) {
        try {
            const response = await ApiService.post(`${apiUrlRecurso}/${page}`, data);
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();
            return response.data.success;
        }catch (error){
            console.log(error);
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    edit: async function(data) {
        try {
            const response = await ApiService.put(apiUrlRecurso,data);
            console.log(response);
            ApiService.mount401Interceptor();
            return response.data.success;
        }catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    }

}

export default RecursoService

export { RecursoService, handleError }